import { useState, useEffect } from 'react';
import {
	GetAppDistributionLists,
	GetApplicationManagementByID,
} from '../../_api';
import Section from '../../components/NewApplication/Section';
import Spinner from '../../../../components/UI/Spinner/Spinner';
import DistributionListDisplay from './components/DistributionListDisplay';
const DistributionListConfiguration = ({
	appID,
	currentUser,
	requirementNumber,
	readOnly,
}) => {
	const [appDistributionLists, setAppDistributionLists] = useState(null);
	const [isLoading, setIsLoading] = useState(true);
	const [app, setApp] = useState(null);
	const [apiErrors, setApiErrors] = useState([]);
	//on load, retrieve the AppManagementModel for the selected app
	useEffect(() => {
		reload(appID, setIsLoading, setApp, setAppDistributionLists);
	}, [appID]);

	return (
		<>
			<Section label='Distribution List Configurations'>
				{isLoading ? (
					<Spinner />
				) : (
					<DistributionListDisplay
						appDistributionLists={appDistributionLists}
						appID={appID}
						readOnly={readOnly}
						app={app}
						currentUser={currentUser}
						requirementNumber={requirementNumber}
						reload={() =>
							reload(
								appID,
								setIsLoading,
								setApp,
								setAppDistributionLists
							)
						}
						apiErrors={apiErrors}
						setApiErrors={setApiErrors}
					/>
				)}
			</Section>
		</>
	);
};

export default DistributionListConfiguration;

const reload = (appID, setIsLoading, setApp, setAppDistributionLists) => {
	setIsLoading(true);

	GetApplicationManagementByID(appID).then(resp => setApp(resp));

	GetAppDistributionLists(appID)
		.then(response => {
			setAppDistributionLists(response);
		})
		.then(x => setIsLoading(false));
};
